var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{key:_vm.$route.fullPath},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","id":"calendarSpinner"}}):_vm._e(),_c('v-sheet',{staticClass:"pa-4 calendar-container"},[_c('full-calendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions,"min-height":"600"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }